export default __webpack_public_path__ + "static/media/loader.37afbc23.svg";